import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { HeaderService } from '../../core/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../core/base.component';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../../core/security/auth.service';
import { RolesEnum } from '../../core/security/roles.enum';
import { FilterOptionModel } from '../../dialogs/grid-filter/filter-option.model';
import { MatDialog } from '@angular/material/dialog';
import { CloneRoleDialogComponent, CloneRoleDialogData } from './clone-role-dialog/clone-role-dialog.component';
import { RolesDatasource } from './grid/roles.datasource';
import { RolesManagementService as RolesManagementApiService } from '../../api/services/roles-management.service';
import { AccountRoleModel } from '../../api/models';
import { isNumber } from 'lodash';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { RolesGridComponent } from './grid/roles-grid.component';

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        NgIf,
        MatButton,
        MatTooltip,
        RolesGridComponent,
    ],
})
export class RolesComponent extends BaseComponent implements OnInit {
  detailsUrl: string;
  filterChangeEvent = new EventEmitter<any>();
  filterOptions: FilterOptionModel[] = [];
  dataSource: RolesDatasource;

  constructor(
    route: ActivatedRoute,
    headerService: HeaderService,
    titleService: Title,
    authService: AuthService,
    private readonly _router: Router,
    private readonly _dialog: MatDialog,
    private readonly _rolesManagementApiService: RolesManagementApiService,
  ) {
    super(route, headerService, titleService, authService);

    this.detailsUrl = '../role';
    this.editRoles = [RolesEnum.AccountRoles_Edit, RolesEnum.AccountRoles_Delete];
    this.deleteRoles = [RolesEnum.AccountRoles_Delete];
    this.dataSource = new RolesDatasource(this._rolesManagementApiService);
  }

  get accRoles(): AccountRoleModel[] {
    return this.dataSource?.currentPageData() || [];
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.initFilterOptions();
  }

  public onCreateNewRole(): void {
    this._router.navigate([this.detailsUrl, 'new', 'edit'], { relativeTo: this.route });
  }

  public onCloneRole(): void {
    if (!this.accRoles.length) {
      return;
    }

    const dialogRef = this._dialog.open<CloneRoleDialogComponent, CloneRoleDialogData, string>(
      CloneRoleDialogComponent,
      {
        width: '400px',
        data: {
          selectOptions: this.accRoles.map(role => ({ id: role.id, text: role.name })),
        },
      },
    );

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this._router.navigate([`account/role/${result}/edit`], {
          queryParams: { clone: true },
        });
      }
    });
  }

  public onFilterChanged(filter: any): void {
    this.filterChangeEvent.emit(filter);
  }

  private initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any',
      },
      {
        filterKey: 'name',
        multiValue: false,
        showAlways: true,
        title: 'Name',
        type: 'string',
      },
      {
        filterKey: 'description',
        multiValue: false,
        showAlways: true,
        title: 'Description',
        type: 'string',
      },
    ];
  }
}
